import { useRef, useState } from "react";
import { HelpCircle } from "lucide-react";

interface TooltipProps {
  text: string;
}

export default function Tooltip({ text }: TooltipProps) {
  const [visible, setVisible] = useState(false);
  const [style, setStyle] = useState<React.CSSProperties>({});
  const ref = useRef<HTMLSpanElement>(null);

  if (!text) return null;

  const show = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const top = rect.top - 4;
      // Anchor tooltip's right edge to the icon's right edge so it never overflows
      const right = window.innerWidth - rect.right;
      setStyle({ top, right, transform: "translateY(-100%)" });
      setVisible(true);
    }
  };

  return (
    <span
      ref={ref}
      className="inline-flex items-center ml-0.5"
      onMouseEnter={show}
      onMouseLeave={() => setVisible(false)}
      onFocus={show}
      onBlur={() => setVisible(false)}
      tabIndex={0}
      role="img"
      aria-label={text}
    >
      <HelpCircle className="h-3.5 w-3.5 text-gray-400 dark:text-gray-500 cursor-help" />
      {visible && (
        <span
          role="tooltip"
          className="fixed z-50 w-max max-w-xs px-2.5 py-1.5 text-xs text-left normal-case text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded shadow-lg pointer-events-none"
          style={style}
        >
          {text}
        </span>
      )}
    </span>
  );
}
